/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';

const messages = defineMessages({
  title: {id: 'navigation.settings.food-services.free-and-reduced-lunch'},
});

const FreeAndReducedLunchItem = () => (
  <RouteLinkItem
    route="midas/settings/food-services/free-and-reduced-lunch"
    title={messages.title}
  />
);

export default FreeAndReducedLunchItem;
